import { Suspense, lazy } from 'react'
import { Switch, Redirect } from 'react-router-dom'
import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import { PrivateRoute } from 'routing/components'
import { EnvironmentUtils } from 'utils'
import simulatorTrainingRoutes from 'modules/simulatorTrainings/common/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const Schedules = lazy(
  () =>
    import(
      /* webpackChunkName: "SimulatorTrainingInstructorSLSchedules" */ 'modules/simulatorTrainings/instructor/studentLed/Schedules/pages/Schedules'
    )
)

export const ScheduleEditor = lazy(
  () =>
    import(
      /* webpackChunkName: "SimulatorTrainingInstructorSLScheduleEditor" */ 'modules/simulatorTrainings/instructor/studentLed/Schedules/pages/ScheduleEditor'
    )
)

export const ScheduleCreator = lazy(
  () =>
    import(
      /* webpackChunkName: "SimulatorTrainingInstructorSLScheduleCreator" */ 'modules/simulatorTrainings/instructor/studentLed/Schedules/pages/ScheduleCreator'
    )
)

const SchedulesRouting = () => {
  const { studentLedSchedulesAdd, studentLedSchedulesAvailable, studentLedSchedulesEdit } =
    EnvironmentUtils.getPermissions('simulatorTraining')

  return (
    <Suspense fallback={<RouteChangeProgress mode={Mode.Light} />}>
      <Switch>
        <PrivateRoute
          exact
          path={`${routes.list}/:exerciseId`}
          component={Schedules}
          disabled={!studentLedSchedulesAvailable}
        />
        <PrivateRoute
          exact
          path={`${routes.edit}/:scheduleId`}
          component={ScheduleEditor}
          disabled={!studentLedSchedulesEdit}
        />
        <PrivateRoute
          exact
          path={`${routes.create}/:exerciseId`}
          component={ScheduleCreator}
          disabled={!studentLedSchedulesAdd}
        />
        <Redirect path='*' to={simulatorTrainingRoutes.root} />
      </Switch>
    </Suspense>
  )
}

export default SchedulesRouting
